// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__3RMJP","wrapper":"login_wrapper__3Q8E6","innerWrapper":"login_innerWrapper__KXlZa","otpBox":"login_otpBox__uv0eJ"};